module.exports = __webpack_public_path__ + "static/media/dem_str_sur.278016fd.png";